import { render } from "./zhuboItem.vue?vue&type=template&id=b88c7fd4&scoped=true"
import script from "./zhuboItem.vue?vue&type=script&lang=js"
export * from "./zhuboItem.vue?vue&type=script&lang=js"

import "./zhuboItem.vue?vue&type=style&index=0&id=b88c7fd4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-b88c7fd4"

export default script